import { render } from "./EpxEmsRadio.vue?vue&type=template&id=8f9b3472&scoped=true&ts=true"
import script from "./EpxEmsRadio.vue?vue&type=script&lang=ts"
export * from "./EpxEmsRadio.vue?vue&type=script&lang=ts"

import "./EpxEmsRadio.vue?vue&type=style&index=0&id=8f9b3472&scoped=true&lang=css"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9b3472"]])

export default __exports__